import { DefaultTheme } from 'styled-components'
import { InputProps } from './types'
import { Style } from '@react-pdf/types/style'

const componentStructure = (): Style => ({
  display: 'flex',
  flexDirection: 'column'
})

const labelArea = (
  theme: DefaultTheme,
  { heightClass }: InputProps
): Style => ({
  marginBottom: theme.input[heightClass]?.labelAreaMargin
})

const label = (theme: DefaultTheme, { heightClass }: InputProps): Style => ({
  fontSize: theme.input[heightClass]?.labelSize,
  fontWeight: 'normal',
  marginBottom: 0
})

const inputStructure = (
  theme: DefaultTheme,
  { heightClass }: InputProps
): Style => ({
  paddingHorizontal: theme.input[heightClass]?.paddingX ?? 0,
  paddingVertical: theme.input[heightClass]?.paddingY ?? 0,
  borderTopWidth: 2,
  borderTopColor: `${theme.colors.status.default}`,
  height: `${theme.input[heightClass]?.boxHeight}`,
  backgroundColor: '#ffffff'
})

const input = (theme: DefaultTheme, { heightClass }: InputProps): Style => ({
  fontFamily: 'Barlow',
  color: '#303032',
  fontSize: theme.input[heightClass]?.fontSize,
  padding: 0,
  width: undefined,
  marginRight: 6
})

export default function getStyles(theme: DefaultTheme, inputProps: InputProps) {
  return {
    componentStructure: componentStructure(),
    labelArea: labelArea(theme, inputProps),
    label: label(theme, inputProps),
    inputStructure: inputStructure(theme, inputProps),
    input: input(theme, inputProps)
  }
}
